import React from 'react';

function Footer() {
  return (
    <footer style={{
      padding: 'clamp(2rem, 5vw, 3rem) clamp(1rem, 5vw, 5%)',
      borderTop: '1px solid rgba(255,255,255,0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 'clamp(1rem, 3vw, 2rem)',
      background: '#000000'
    }}>
      <div>
        <div style={{
          fontSize: 'var(--font-sm)',
          fontWeight: '700',
          marginBottom: '0.5rem',
          color: '#87CEEB'
        }}>
          ViralArc.ai
        </div>
        <div style={{
          fontSize: 'var(--font-xxs)',
          color: 'rgba(255, 255, 255, 0.5)'
        }}>
          © 2025 ViralArc.ai. All rights reserved.
        </div>
      </div>
      <div style={{
        display: 'flex',
        gap: 'clamp(1rem, 3vw, 2rem)',
        justifyContent: 'flex-end',
        flexWrap: 'wrap'
      }}>
        <a
          href="/privacy-policy"
          style={{
            color: 'rgba(255, 255, 255, 0.7)',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            fontSize: 'var(--font-xxs)',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.color = '#87CEEB'}
          onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
        >
          隱私政策
        </a>
        <a
          href="/terms-of-service"
          style={{
            color: 'rgba(255, 255, 255, 0.7)',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            fontSize: 'var(--font-xxs)',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.color = '#87CEEB'}
          onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
        >
          服務條款
        </a>
        <a
          href="mailto:official@viralarc-ai.com"
          style={{
            color: 'rgba(255, 255, 255, 0.7)',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            fontSize: 'var(--font-xxs)',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.color = '#87CEEB'}
          onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
        >
          聯絡我們
        </a>
      </div>
    </footer>
  );
}

export default Footer;
